<template>
  <div
    :class="`reservation ${$store.state.isMobile ? '' : 'isPc'} ${$store.state.isMobile && showAdd ? 'onPage' : ''}`">
    <innerWarp v-show="$store.state.isMobile && !showNotice && !showExplaxinInfo">
      <slot>
        <!-- 预约日期 -->
        <div class="calendarWarp">
          <div class="itemContentTitle">预约日期</div>
          <div class="calendarDetail" v-if="calendar1.begin.length && $store.state.isMobile">
            <calendar :range="calendar1.range" :events="calendar1.events" :lunar="calendar1.lunar"
              :value="calendar1.value" :begin="calendar1.begin" :end="calendar1.end" :weeks="calendar1.weeks"
              :months="calendar1.months" :disabled="calendar1.disabled" @select="selectDate" ref="calendarDom"
              :isMobile="true"></calendar>
            <div class="itemWarpTime timeWarp" v-if="!closeReservation">
              <div class="contentTitle">入场时间</div>
              <div class="timeInSelected" @click="handelTimeIn" v-if="!loadingTimeDetail">{{ `${selectedDate ?
      timeIn.label || '今日预约已结束' : '今日闭馆'}` }}</div>
              <div v-else class="timeInSelected">加载中</div>
            </div>
            <div class="itemWarpTime">
              <div class="contentTitle">预约类型</div>
              <el-radio-group v-model="reservationType" :disabled="closeReservation || !selectedDate">
                <el-radio :label="1" v-if="$store.state.ticketDetail.perOn">个人</el-radio>
                <el-radio :label="2" v-if="$store.state.ticketDetail.orgOn">{{
      `团队${`${$store.state.ticketDetail.orgNumMin ?
        `(${$store.state.ticketDetail.orgNumMin}~${$store.state.ticketDetail.orgNumMax})人` :
        ''}`}` }}</el-radio>
              </el-radio-group>
            </div>
          </div>
        </div>
        <div v-if="closeReservation" class="closeReservation">该日闭馆，可选择其它日期预约</div>
        <!-- 个人预约参观人 -->
        <personal @delData="delData" type="personal" :datas="personals"
          v-if="reservationType == 1 && !closeReservation && selectedDate" @handelShowAdd="handelShowAdd"
          :maxPersonal="maxPersonal" ref="personal" @changeSelectData="changeSelectData" @editPersonal="editPersonal">
        </personal>
        <!-- 个人预约儿童 -->
        <personal @delData="delData" type="child" :datas="childs"
          v-if="reservationType == 1 && $store.state.ticketDetail.childrenOn && !closeReservation && selectedDate"
          :maxChildNum="maxChildNum" @handelShowAdd="handelShowAdd" @editPersonal="editPersonal" ref="child"
          :isMobile="true" @selectedHasChild="selectedHasChild" @changeSelectData="changeSelectData"
          @changeChildNumber="changeChildNumber" :fillChildrenInfo="fillChildrenInfo"></personal>
        <!--  <div class="itemCard otherH5Project" style="margin-top: 40px;" v-if="timeInProject.chair || timeInProject.flyingCinema">
          <div :class="`itemWarp ${hasProject == 2 ? 'hasProject' : ''}`">
            <div class="contentTitle">是否预约场馆项目</div>
            <br/>
            <el-radio-group v-model="hasProject">
              <el-radio :label="1">否</el-radio>
              <el-radio :label="2">是</el-radio>
            </el-radio-group>
            <br/>
            <div v-if="hasProject == 2" class="projectWarp">
              <div class="projectTitle">蛋壳椅(最多{{maxProjectNum_c}}位)：</div>
              <el-input v-model="chairNum" type="number" :max="maxProjectNum_c"></el-input>
              <div class="projectTitle">飞行影院(最多{{maxProjectNum_f}}位)：</div>
              <el-input v-model="flyingCinemaNum" type="number" :max="maxProjectNum_f"></el-input>
            </div>
          </div>
        </div> -->
        <!-- 个人须知 -->
        <div class="noticeWarp" v-if="reservationType == 1">
          <div class="itemCard certificate" v-if="$store.state.ticketDetail.imgPersonOn && !closeReservation">
            <span class="contentTitle">请点击上传个人凭证</span>
            <el-upload ref="upload" class="upload-demo" :limit="1" action="1111" accept=".jpg,.png,.jpeg"
              list-type="picture" :http-request="actionImg" :show-file-list="false">
              <div class="buttonText buttonLeft">
                {{ uploadIng ? '上传中' : '点击上传凭证' }}
              </div>
            </el-upload>
            <br />
            <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
              <img :src="item" @click="openBigImg(item)">
              <span @click="delImg(index)"></span>
            </div>
          </div>
          <div v-if="$store.state.ticketDetail.personFile" class="fileDemo"
            @click="downFile($store.state.ticketDetail.personFile)">下载个人凭证模板</div>
          <div class="itemWarpLine" v-if="!closeReservation">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <!-- {{ museumCode }} -->
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">
              {{ museumCode == "hnsczsbwg" ? '预约须知' : "个人预约须知" }}
            </span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>
        <!-- 团队信息 -->
        <div v-if="reservationType == 2">
          <div class="itemContentTitle">团队信息</div>
          <div class="itemCard" v-if="belongData.length">
            <div class="lineContent">
              <div class="name">常用团队</div>
              <el-select v-model="otherData" placeholder="请选择常用团队" @change="selectGroup" value-key="id">
                <el-option v-for="item in belongData" :label="item.orgName" :value="item" :key="item.id"></el-option>
              </el-select>
            </div>
            <div v-if="selectGroupId">
              <div class="lineContent" style="margin-bottom: 0.2rem;">
                <div class="name">团队负责人</div>
                <div style="width: 100%; text-align: left;">&nbsp;{{ $store.state.selectGroup.personName }}</div>
              </div>
              <div class="lineContent">
                <div class="name">证件号码</div>
                <div style="width: 100%; text-align: left;">&nbsp;{{ $store.state.selectGroup.cardNum }}</div>
              </div>
              <div class="lineContent" style="margin-top: 0.2rem">
                <div class="name">联系电话</div>
                <div style="width: 100%; text-align: left;">&nbsp;{{ $store.state.selectGroup.phone }}</div>
              </div>
            </div>
          </div>
          <div class="addNewGroup" :style="!$store.state.ticketDetail.explainOn ? 'margin-bottom: 0.4rem' : ''"
            @click="addNewGroup" v-if="belongData.length">新增团队</div>
          <team :team="team" :showAddNewGroup="showAddNewGroup" :museumCode="museumCode" v-if="!selectGroupId"></team>
          <div v-if="showAddNewGroup && !selectGroupId" class="itemCard explain">
            <span class="contentTitle">是否设为常用团队</span>
            <el-radio-group v-model="team.common" style="margin-top: 0.15rem;">
              <el-radio :label="false">否</el-radio>
              <el-radio :label="true">是</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div v-if="!$store.state.ticketDetail.teamInfoRegister && reservationType == 2" class="itemCard teamNumber">
          <div class="lineContent">
            <div class="name">团队人数</div>
            <el-input v-model="teamNumber" placeholder="请输入团队人数" type="number"></el-input>
          </div>
        </div>
        <!-- 
          v-if="$store.state.ticketDetail.explainOn && (!$store.state.ticketDetail.teamInfoRegister || isFid)&&(maxExplainNum != 'no'&&maxExplainNum!=0)"
         -->
        <div v-if="!closeReservation && reservationType == 2">
          <div
            v-if="$store.state.ticketDetail.explainOn && (!$store.state.ticketDetail.teamInfoRegister || isFid) && maxExplainNum != 'no'">
            <div class="members">
              <div>{{ museumCode == 212594 ? '专人讲解' : '语音讲解' }}</div>
            </div>
            <div :class="`itemCard explain`">
              <span class="contentTitle">是否需要讲解</span>
              <el-radio-group v-model="needExplain" :disabled="!maxExplainNum" style="margin-top: 0.15rem;">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是<span>(该时段剩余{{ maxExplainNum }})</span></el-radio>
              </el-radio-group>
              <div class="explainInfo" v-if="explainInfo" @click="openExplainInfo">查看讲解说明</div>
            </div>
          </div>
          <div :class="`itemCard certificate ${$store.state.isMobile ? 'isMobile' : ''}`"
            v-if="$store.state.ticketDetail.imgOrgOn">
            <span class="contentTitle">请上传团队凭证</span>
            <el-upload ref="upload" class="upload-demo" :limit="1" action="1111" accept=".jpg,.png,.jpeg"
              list-type="picture" :http-request="actionImg" :show-file-list="false">
              <div class="buttonText buttonLeft">
                {{ uploadIng ? '上传中' : '点击上传凭证' }}
              </div>
            </el-upload>
            <!--   -->
            <br />
            <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
              <img :src="item" @click="openBigImg(item)">
              <span @click="delImg(index)"></span>
            </div>
            <!--  <div v-if="hasUpload" class="buttonText hasUpload">已上传</div>
            <div v-if="hasUpload" class="buttonText cancelUpload" @click="hasUpload = false">取消</div> -->
          </div>
          <div v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
            @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</div>
          <div class="itemWarpLine" v-if="$store.state.isMobile">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">
              {{ museumCode == "hnsczsbwg" ? '预约须知' : "团队预约须知" }}
            </span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>

        <div class="buttonNormal" @click="handelButton(reservationType)" v-if="!closeReservation && reservationType">
          {{ reservationType == 1 || !$store.state.ticketDetail.teamInfoRegister ? '确认预约' : '添加成员信息' }}</div>
        <!-- 新增or编辑 -->
        <addCard v-if="showAdd" @handelShowAdd="handelShowAdd" @saveAddPerson="saveAddPerson" :cardTypes="cardTypes"
          :addDetail="addDetail" :addType="addType" :editDetaiType="editDetaiType" :personals="personals"
          @changeAddDetail="changeAddDetail"></addCard>
      </slot>
    </innerWarp>
    <van-popup v-model="showPopup" position="bottom">
      <van-picker title="入场时间" show-toolbar :columns="timeOptions" @confirm="onConfirm" @cancel="onCancel"
        @change="onChange" value-key="label" />
    </van-popup>
    <!-- pc端 -->
    <div v-show="!$store.state.isMobile">
      <topBanner></topBanner>
      <div class="pcContent handelBlock">
        <div class="buttonLine">
          <div class="buttonRed">
            <el-select v-model="reservationType">
              <el-option :value="1" label="个人" v-if="$store.state.ticketDetail.perOn"></el-option>
              <el-option :value="2"
                :label="`团队${`${$store.state.ticketDetail.orgNumMin ? `(${$store.state.ticketDetail.orgNumMin}~${$store.state.ticketDetail.orgNumMax})人` : ''}`}`"
                v-if="$store.state.ticketDetail.orgOn"></el-option>
            </el-select>
          </div>
          <div class="buttonWhite" @click="toOrders">{{ isFid ? '个人中心' : '我的订单' }}</div>
          <div class="pcToIndex" @click="toIndex">返回首页</div>
        </div>
        <div class="line" v-if="$store.state.ticketDetail.timeOpen">
          开馆时间<span>{{ $store.state.ticketDetail.timeOpen }}-{{ $store.state.ticketDetail.timeClose }}</span>
          <div class="pcStopTime" v-if="$store.state.ticketDetail.timeStop">停止入馆时间</div>
          <span v-if="$store.state.ticketDetail.timeStop">{{ $store.state.ticketDetail.timeStop }}</span>
        </div>
        <div class="pcItemCard">
          <div class="itemTitle">预约日期</div>
          <div class="pcCalendar" v-if="calendar1.begin.length">
            <calendar :range="calendar1.range" :events="calendar1.events" :lunar="calendar1.lunar"
              :value="calendar1.value" :begin="calendar1.begin" :end="calendar1.end" :weeks="calendar1.weeks"
              :months="calendar1.months" :disabled="calendar1.disabled" @select="selectDate" :isMobile="false"
              ref="calendarDom"></calendar>
            <div class="mouthText">月</div>
          </div>
          <div v-if="!closeReservation" class="timeDetail">
            <div class="itemTitle">入场时间</div>
            <div :class="`timeAndTicket ${selectedTimeIndex == index ? 'selectedTime' : ''}`"
              v-for="(item, index) in timeOptions" :key="index" @click="selectTime(item, index)"
              v-show="!loadingTimeDetail">{{ item.label }}</div>
            <div style="font-size: 30px; text-align: center;" v-if="!timeOptions.length && !loadingTimeDetail">
              {{ !selectedDate ? '今日闭馆' : '今日预约已结束' }}</div>
            <div style="font-size: 30px; text-align: center;" v-if="loadingTimeDetail">加载中</div>
          </div>
          <div v-else class="closeReservation">该日闭馆，可选择其它日期预约</div>
        </div>
        <personal @delData="delData" type="personal" :datas="personals"
          v-show="reservationType == 1 && !closeReservation && selectedDate" @handelShowAdd="handelShowAdd"
          :maxPersonal="maxPersonal" ref="personal" @changeSelectData="changeSelectData" @editPersonal="editPersonal">
          <slot>
            <div class="itemTitle">请选择参观人<span v-if="maxPersonal"></span>（最多{{ maxPersonal }}人）</div>
          </slot>
        </personal>
        <personal @delData="delData" type="child" :datas="childs" :maxChildNum="maxChildNum"
          v-if="reservationType == 1 && $store.state.ticketDetail.childrenOn && !closeReservation && selectedDate"
          @handelShowAdd="handelShowAdd" ref="child" :isMobile="false" @editPersonal="editPersonal"
          @selectedHasChild="selectedHasChild" @changeSelectData="changeSelectData" style="margin-bottom: 40px;"
          @changeChildNumber="changeChildNumber" :fillChildrenInfo="fillChildrenInfo"></personal>
        <!-- <div class="itemCard otherPcProject" v-if="timeInProject.chair || timeInProject.flyingCinema" :style="`margin: 0.2rem 0;${hasProject == 2 ? 'padding-bottom: 70px' : ''}`">
          <div class="itemWarp">
            <div class="contentTitle">是否预约场馆项目</div>
            <el-radio-group v-model="hasProject">
              <el-radio :label="1">否</el-radio>
              <el-radio :label="2">是</el-radio>
            </el-radio-group>

            <div v-if="hasProject == 2" class="projectWarp">
              <div class="projectTitle">蛋壳椅(最多{{maxProjectNum_c}}位)：</div>
              <el-input v-model="chairNum" type="number" :max="maxProjectNum_c"></el-input>
              <div class="projectTitle">飞行影院(最多{{maxProjectNum_f}}位)：</div>
              <el-input v-model="flyingCinemaNum" type="number" :max="maxProjectNum_f"></el-input>
            </div>
          </div>
        </div> -->
        <!-- 个人凭证 -->
        <div class="itemCard pcItemCard"
          v-if="reservationType == 1 && $store.state.ticketDetail.imgPersonOn && !closeReservation">
          <div class="itemWarpLine certificate" style="margin-left: -0.06rem">
            <span class="contentTitle">请点击上传个人凭证</span>
            <el-upload ref="upload2" class="upload-demo" :limit="1" action="1111" accept=".jpg,.png,.jpeg"
              list-type="picture" :http-request="actionImg" :show-file-list="false">
              <div class="buttonText buttonLeft">
                {{ uploadIng ? '上传中' : '点击上传凭证' }}
              </div>
            </el-upload>
            <span v-if="$store.state.ticketDetail.personFile" class="fileDemo"
              @click="downFile($store.state.ticketDetail.personFile)">下载个人凭证模板</span>
            <br />
          </div>
          <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
            <img :src="item" @click="openBigImg(item)">
            <span @click="delImg(index)"></span>
          </div>
        </div>
        <div class="noticeWarp" v-if="reservationType == 1 && !closeReservation">

          <div class="itemWarpLine">
            <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
            <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">
              {{ museumCode == "hnsczsbwg" ? '预约须知' : "个人预约须知" }}



            </span>
            <div class="noticeText">请仔细阅读后勾选</div>
          </div>
        </div>
        <div class="itemCard pcItemCard" v-if="reservationType == 2 && !closeReservation">
          <!-- <div class="contentTitle">团队信息</div> -->
          <div class="buttonGroup">
            <div :class="`itemTitle addGroup ${showAddNewGroup ? 'gray' : ''}`" v-if="belongData.length"
              @click="showAddNewGroup = false">选择常用团队</div>
            <div :class="`itemTitle addGroup ${!showAddNewGroup ? 'gray' : ''}`" style="cursor: pointer;"
              @click="addNewGroup" v-if="belongData.length">新增团队</div>
          </div>
          <div v-show="belongData.length && !showAddNewGroup" v-for="(item) in belongData" :key="item.id"
            :class="`groupItem ${item.id == selectGroupId ? 'activeGroup' : ''}`" @click="selectGroup(item)">
            {{ item.orgName }}</div>
          <div v-if="selectGroupId">
            <div class="itemTitle">团队信息</div>
            <div class="lineContent" style="margin-bottom: 0.2rem;">
              <div class="name">团队负责人</div>
              <div style="text-align: left;">&nbsp;{{ $store.state.selectGroup.personName }}</div>
              <div class="name" style="margin-left: 40px; width: 130px">证件号码</div>
              <div style="text-align: left;">&nbsp;{{ $store.state.selectGroup.cardNum }}</div>
              <div class="name" style="margin-left: 40px; width: 130px">联系电话</div>
              <div style="text-align: left;">&nbsp;{{ $store.state.selectGroup.phone }}</div>
            </div>
          </div>

          <div class="lineBgc" v-if="showAddNewGroup && !selectGroupId">
            <div class="left">
              <div class="lineContent">
                <div class="name">团队名称</div>
                <el-input v-model="team.orgName" placeholder="请输入团队名称"></el-input>
              </div>
              <div class="lineContent">
                <div class="name">团队负责人</div>
                <el-input v-model="team.personName" placeholder="请输入团队负责人" :maxlength="16"
                  :disabled="team.disabled"></el-input>
              </div>
              <!-- <div class="lineContent lastLine">
                <div class="name">成员信息</div>
                <div class="buttonText buttonLeft" @click="uploadModel">下载模板</div>
              </div> -->
            </div>
            <div class="right">
              <div class="lineContent">
                <div class="name">身份证号码</div>
                <el-input v-model="team.cardNum" placeholder="请输入证件号码"
                  :disabled="team.disabled && team.cardType == 1"></el-input>
              </div>
              <div class="lineContent">
                <div class="name">联系电话</div>
                <el-input v-model="team.phone" placeholder="请输入联系电话" :disabled="team.disabled"></el-input>
              </div>
            </div>
          </div>
          <div class="lineContent" style="margin-bottom: 10px" v-if="!$store.state.ticketDetail.teamInfoRegister">
            <div class="contentTitle" style="margin-bottom: 0; padding-left: 45px;">团队人数</div>
            <el-input v-model="teamNumber" placeholder="请输入团队人数" type="number"></el-input>
          </div>
          <div v-if="reservationType == 2" class="itemCard teamNumber">
            <div class="itemWarpLine certificate" style="margin: 0 0" v-if="showAddNewGroup && !selectGroupId">
              <span class="contentTitle">是否设为常用团队</span>
              <el-radio-group v-model="team.common" style="margin-left: 50px;">
                <el-radio :label="false">否</el-radio>
                <el-radio :label="true">是</el-radio>
              </el-radio-group>
            </div>
            <div class="itemWarpLine" style="margin: 0 0"
              v-if="(!$store.state.ticketDetail.teamInfoRegister || isFid) && $store.state.ticketDetail.explainOn && (maxExplainNum != 'no')">
              <span class="contentTitle explain">是否需要讲解</span>
              <el-radio-group v-model="needExplain" :disabled="!maxExplainNum" style="margin-left:115px">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是<span v-if="maxExplainNum != 'no'">(该时段剩余{{ maxExplainNum }})</span></el-radio>
              </el-radio-group>
            </div>
            <!-- <div class="explainInfo" v-if="explainInfo" @click="openExplainInfo">查看讲解说明</div> -->
            <div class="explainInfo"
              v-if="(!$store.state.ticketDetail.teamInfoRegister || isFid) && $store.state.ticketDetail.explainOn && (maxExplainNum != 'no')"
              @click="openExplainInfo">查看讲解说明</div>
            <div class="itemWarpLine certificate" v-if="$store.state.ticketDetail.imgOrgOn">
              <span class="contentTitle">请上传团队凭证图片</span>
              <el-upload ref="upload2" class="upload-demo" :limit="1" action="1111" accept=".jpg,.png,.jpeg"
                list-type="picture" :http-request="actionImg" :show-file-list="false">
                <div class="buttonText buttonLeft">
                  {{ uploadIng ? '上传中' : '点击上传凭证' }}
                </div>
              </el-upload>
              <span v-if="$store.state.ticketDetail.teamFile" class="fileDemo"
                @click="downFile($store.state.ticketDetail.teamFile)">下载团队凭证模板</span>
              <br />
            </div>
            <div v-show="certificate.length" class="uploadImgs" v-for="(item, index) in certificate" :key="item">
              <img :src="item" @click="openBigImg(item)">
              <span @click="delImg(index)"></span>
            </div>
            <div class="itemWarpLine" style="display: block; text-align: center;"
              v-if="!$store.state.ticketDetail.teamInfoRegister">
              <el-checkbox v-model="hasReadNotice" @change="changeReadNotice"></el-checkbox>
              <span :class="`notice ${hasReadNotice ? 'isNoticed' : ''}`" @click="clickNotice">

                {{ museumCode == "hnsczsbwg" ? '预约须知' : "团队预约须知" }}

              </span>
              <div class="noticeText">请仔细阅读后勾选</div>
            </div>
          </div>
        </div>
        <div :class="`button3 ${!$store.state.isMobile ? 'pcButton3' : ''}`" @click="handelButton(1)"
          v-if="reservationType == 1 && !closeReservation">确认预约</div>
        <div class="buttonsWarp" v-if="reservationType == 2 && !closeReservation">
          <!-- <el-upload
            v-if="!hasModel && $store.state.ticketDetail.teamInfoRegister"
            class="upload-demo"
            action="1111"
            ref="uploadModel"
            :http-request="actionModel"
            :limit="1"
            :show-file-list="false">
            <div class="button4">上传模板</div>
          </el-upload> -->
          <div class="button3" @click="handelButton(2)" v-if="reservationType == 2">
            {{ $store.state.ticketDetail.teamInfoRegister ? '添加成员信息' : '确认预约' }}</div>
        </div>
        <pop v-if="showAdd" :editDetaiType="editDetaiType">
          <slot>
            <div class="popContent">
              <div class="title">{{ addType == 'personal' ? (personals.length ? '添加成员' : '完善您的个人信息') : '添加儿童信息' }}</div>
              <div class="baseLine"></div>
              <div class="lineContent">
                <div class="name">姓名</div>
                <el-input v-model="addDetail.personName" :maxlength="16" placeholder="请输入姓名"
                  oninput="if(value.length>20)value=value.slice(0,20)"></el-input>
              </div>
              <div v-if="addType == 'personal'">
                <div class="lineContent">
                  <div class="name">证件类型</div>
                  <el-select v-model="addDetail.cardType" placeholder="请选择">
                    <el-option v-for="item in cardTypes" :key="item.val" :label="item.name" :value="item.val">
                    </el-option>
                  </el-select>
                </div>
                <div class="lineContent">
                  <div class="name">证件号码</div>
                  <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">联系电话</div>
                  <el-input v-model="addDetail.phone" placeholder="请输入联系电话" type="number"
                    oninput="if(value.length>11)value=value.slice(0,11)" :disabled="addDetail.phoneDisabled"></el-input>
                </div>
              </div>
              <div v-else>
                <div class="lineContent" v-if="$store.state.ticketDetail.childCardNumOn">
                  <div class="name">证件号码</div>
                  <el-input v-model="addDetail.cardNum" placeholder="请输入证件号码"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">年龄(岁)</div>
                  <el-input v-model="addDetail.age" placeholder="请输入年龄" type="number"></el-input>
                </div>
                <div class="lineContent">
                  <div class="name">性别</div>
                  <el-radio-group v-model="addDetail.gender">
                    <el-radio :label="1">男</el-radio>
                    <el-radio :label="2">女</el-radio>
                  </el-radio-group>
                </div>
              </div>
              <div class="tips" v-if="addDetail.haveOrder">该用户有过历史订单，暂不支持修改基本信息</div>
              <div class="buttonConfirm" @click="!addDetail.haveOrder ? saveAddPerson(addDetail) : showAdd = false">
                {{ !addDetail.haveOrder ? '保存' : '关闭' }}</div>
            </div>
          </slot>
        </pop>
      </div>
    </div>
    <temp v-if="showTemp" :imgUrl="tempImgUrl"></temp>
    <notice v-if="(showExplaxinInfo || showNotice) && $store.state.isMobile" :readTime="readTime"
      :showExplaxinInfo="showExplaxinInfo" :explainInfo="explainInfo"></notice>
    <pop v-if="(showExplaxinInfo || showNotice) && !$store.state.isMobile">
      <slot>
        <div class="popContent popNoticeContent">
          <div class="popContentTitle">预约须知</div>
          <div class="popNotice" v-html="showExplaxinInfo ? explainInfo : $store.state.ticketDetail.bookingNote">
          </div>
        </div>
        <div class="buttonWarp">
          <div :class="`buttonConfirm popHasRead ${readTime && !showExplaxinInfo ? 'gayText' : ''}`" @click="hasRead">
            已读{{ readTime && !showExplaxinInfo ? `(${readTime}s)` : '' }}</div>
        </div>
      </slot>
    </pop>
    <div class="bigImg" v-if="showBigImg">
      <div class="placeholder" @click="showBigImg = false"></div>
      <div class="imgWarp">
        <img :src="bigImgUrl">
      </div>
    </div>
  </div>
</template>

<script>
import innerWarp from '../../components/common/innerWarp.vue'
import calendar from "@/components/calendar/calendar.vue";
import personal from '@/components/ticket/personal';
import team from '@/components/ticket/team'
import addCard from '@/components/ticket/addCard'
import topBanner from '../../components/common/topBanner'
import pop from '../../components/common/pop'
import notice from '../../components/common/notice.vue'
import temp from '../../components/common/temp.vue'
import Popup from 'vant/lib/popup';
import 'vant/lib/popup/style';
import Picker from 'vant/lib/picker';
import 'vant/lib/picker/style';
var timeInterval
export default {
  data() {
    return {
      calendar1: {
        range: false,
        value: [],
        disabled: ["2019", "8", "3"],
        // lunar:true, //显示农历
        weeks: ["日", "一", "二", "三", "四", "五", "六"],
        months: [
          "1月",
          "2月",
          "3月",
          "4月",
          "5月",
          "6月",
          "7月",
          "8月",
          "9月",
          "10月",
          "11月",
          "12月"
        ],
        events: {
          '2022,3,2': '闭馆'
        },
        begin: [], //可选开始日期
        end: [], //可选结束日期
      },
      advanceBookingDays: 0,
      showTemp: false,
      reservationType: '', //预约类型
      timeIn: '',//入场时间value
      timeOptions: [], //入场时间及余票数
      selectedTimeIndex: -1, //选中的入场时间index
      personals: [],//参观人可选列表
      showAdd: false, //开启添加成员
      team: {
        common: false
      },
      childs: [], //儿童列表
      maxChildNum: 0, //携带儿童计算的最大数
      personalHasChild: 2, //每个参观人可携带的儿童
      addDetail: {},
      cardTypes: [
        { name: '身份证', val: 1 },
        { name: '护照（Passport）', val: 2 },
        { name: '台胞证', val: 5 },
        { name: '军官证', val: 6 },
        { name: '外国人永居证', val: 7 },
        { name: '港澳居民来往内地通行证', val: 3 },
      ],
      addType: '', //新增类型 personal 个人信息 child 儿童
      hasReadNotice: false, //须知已读
      editDetaiType: 'add',
      showNotice: false,
      showPopup: false,
      museumCode: '',
      belongData: [],
      belongId: '',
      selectGroupId: undefined,
      selectedDate: '',
      showAddNewGroup: false,
      otherData: '',
      fromData: {},
      hasModel: false,
      selectPersons: [],
      selectChilds: [],
      hasChild: 1,
      closeReservation: false,
      needExplain: 1,
      maxExplainNum: 0,
      certificate: [],
      uploadIng: false,
      teamNumber: '',
      showBigImg: false,
      bigImgUrl: '',
      hasClick: false,
      flyingCinemaNum: '',
      chairNum: '',
      hasProject: 1,
      maxProjectNum_c: 0,
      maxProjectNum_f: 0,
      hasOpenNotice: false,
      userInfo: {},
      isFid: false,
      readTime: 3,
      timeInProject: {},
      childNumber: '', //不需要儿童信息的时候儿童数量
      fillChildrenInfo: true, //是否需要儿童信息 兼容老平台的数据，默认为显示
      explainInfo: '',//讲解说明
      showExplaxinInfo: false, //讲解说明开启
      loadingTimeDetail: false,
      tempImgUrl: ''
    };
  },

  components: {
    innerWarp,
    calendar,
    personal,
    team,
    addCard,
    topBanner,
    pop,
    notice,
    temp,
    'van-popup': Popup,
    'van-picker': Picker
  },

  methods: {
    // 打开讲解说明
    openExplainInfo() {
      this.showExplaxinInfo = true
    },
    // 修改儿童数量
    changeChildNumber(value) {
      this.childNumber = value
    },
    // 点击预约须知
    changeReadNotice() {
      if (!this.hasOpenNotice) this.showNotice = true
    },

    onSuccess(res, file) {

    },

    openBigImg(item) {
      this.showBigImg = true
      this.bigImgUrl = item
    },

    delImg(index) {
      this.certificate.splice(index, 1)
    },

    actionImg(params) {
      this.uploadIng = true
      let formData = new FormData();
      let museumCode = this.$cookie.get('museumCode') || this.$route.query.museumCode
      formData.append("file", params.file);
      formData.append('folder', `${museumCode}/newTicket`)
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      this.$ajax.post('/api/file/upload/single', formData, config).then((res) => {
        console.log('res')
        console.log(res)
        this.uploadIng = false
        // let url = 
        this.certificate.push(res.data.http.replace('https://p.ananas.chaoxing.com', 'https://museum.chaoxing.com'))
        this.$refs["upload"].clearFiles();
        this.$refs["upload2"].clearFiles();
      }).catch((res) => {
        console.log('re1s')
        console.log(res)
        // location.reload()
        // if (!res) {
        //   this.$router.push({ path: '/ticket/login', query: this.$router.app._route.query })
        // } else {

        // }
        this.$refs["upload"].clearFiles();
        this.$refs["upload2"].clearFiles();
      })
    },

    // downFile(file) {
    //   let imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
    //   if (this.$store.state.isMobile) {
    //     this.tempImgUrl = imageStateUrl + file
    //     this.showTemp = true
    //   } else {
    //     window.open(imageStateUrl + file)
    //   }


    // },
    isPhotoFormat(url) {
      const photoExtensions = /\.(jpg|jpeg|png|gif|bmp|webp)$/i;
      return photoExtensions.test(url);
    },

    downFile(file) {
      console.log(this.isPhotoFormat(file))
      let imageStateUrl = !isNaN(Number(this.$store.state.museumCode)) ? '' : Glob.imgUrl
      console.log(imageStateUrl + file)
      if (this.isPhotoFormat(file)) {
        this.tempImgUrl = imageStateUrl + file
        this.showTemp = true
      } else {
        this.downloadFile(imageStateUrl + file)
      }

    },
    downloadFile(url) {

      if (url.indexOf('http:') === 0) {
        url = url.replace(/http:/g, 'https:')
      }
      url = url.replace('https://d0.ananas.chaoxing.com', 'https://museum.chaoxing.com')
      // 创建一个<a></a >标签
      const a = document.createElement('a');
      a.href = url;
      // 障眼法藏起来a标签
      a.style.display = 'none';
      // 将a标签追加到文档对象中
      document.body.appendChild(a);
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click();
      // 一次性的,用完就删除a标签
      a.remove();
    },
    addNewGroup() {
      this.showAddNewGroup = true
      this.selectGroupId = ''
      this.otherData = ''
      this.team.common = false
      if (!this.userInfo.id) return
      this.team.disabled = true
      this.team.phone = this.userInfo.phone
      this.team.personName = this.userInfo.personName
      if (this.userInfo.cardType == 1) {
        this.team.cardNum = this.userInfo.cardNum
        this.team.cardType = 1
      }
    },
    selectGroup(item) {
      if (this.selectGroupId == item.id) return this.selectGroupId = undefined
      this.selectGroupId = item.id
      this.$store.state.selectGroup = item
    },

    handelTimeIn() {
      this.showPopup = true
    },

    clickNotice() {
      this.showNotice = true
    },
    toOrders() {
      let query = this.$route.query
      query.rType = this.reservationType
      if (this.isFid) return this.$router.push({ path: '/ticket/personalCenter', query })
      this.$router.push({ path: '/ticket/orders', query })
    },

    toIndex() {
      this.$router.push({ path: '/ticket/home', query: this.$route.query })
    },

    selectDate(value) {
      if (!value[1]) {
        // value[0] += 1
        value[1] = 12
      }
      this.selectedDate = value.join('/');
    },

    uploadModel() {
      let text = '团队成员模板.xlsx'
      location.href = encodeURI(location.origin + location.pathname + text)
    },

    // 清除上传团队模板
    clearModelFile() {
      // if (!this.$store.state.ticketDetail.teamInfoRegister && !this.$refs.uploadModel) return 
      // this.$refs.uploadModel.clearFiles()
    },

    getTimeDetail() {
      // console.log('初始化了')
      if (!this.selectedDate) return
      this.closeReservation = false
      this.loadingTimeDetail = true
      this.$ajax(`/api/ticket/front/time-setting?museumCode=${this.museumCode}&date=${this.selectedDate}&ticketId=${this.$store.state.ticketDetail.id || this.$route.query.id}${this.isFid ? `&type=${this.reservationType == 1 ? 0 : 1}` : ''}`).then((res) => {
        if (this.$store.state.ticketDetail.bookingDays == 0) {
          res.data = []
        }
        if (res.data == '该日闭馆。') {
          this.loadingTimeDetail = false
          return this.closeReservation = true
        }
        res.data = res.data.filter((item) => { return item.endTime && item.startTime })
        // 团队是否被限制
        res.data = res.data.filter((item) => { return !((item.teamCountType == 2 && (item.numLimt - item.teamCount <= 0)) || (item.teamCountType == 1 && item.numLimt - item.orderCount <= 0)) })
        // 个人预约的限制
        if (this.reservationType == 1) {
          res.data = res.data.filter((item) => { return !item.numLimt || (item.numLimt - item.orderCount > 0) })
        }

        res.data = res.data.map((item) => {
          if (item.teamCountType == 2) {
            item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.teamCount}` : ''}`
          } else {
            item.label = `${item.startTime.substring(0, 5)}-${item.endTime.substring(0, 5)} ${item.numLimt ? `余票${item.numLimt - item.orderCount}` : ''}`
          }
          return item
        })
        let date = new Date().getHours() * 3600 + new Date().getMinutes() * 60
        console.log(this.selectedDate)
        let timeD = Date.parse(new Date()) - Date.parse(this.selectedDate.replaceAll('-', '/'))
        if (timeD > 0) { //今天
          this.timeOptions = res.data.filter((item) => {
            return item.endTime.split(':')[0] * 3600 + item.endTime.split(':')[1] * 60 > date
          })
        } else {
          this.timeOptions = res.data
        }
        console.log('this.timeIn')
        console.log(this.timeOptions)
        this.loadingTimeDetail = false
        this.timeIn = this.timeOptions[0] || {}
        this.selectedTimeIndex = 0
        this.maxProjectNum_c = this.timeInProject.chair ? this.timeInProject.chair - this.timeInProject.orderChairCount : 0
        this.maxProjectNum_f = this.timeInProject.flyingCinema ? this.timeInProject.flyingCinema - this.timeInProject.orderFlyingCinemaCount : 0
        // this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
        this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'

      })
    },

    // 提交
    handelButton(type) {
      if (!this.timeIn.id) {
        this.clearModelFile()
        return this.$message.error('请选择入场时间')
      }
      if (type == 2) { //团队预约
        if (!this.$store.state.ticketDetail.teamInfoRegister && !this.teamNumber) return this.$message.error('请输入团队人数！')
        if ((!this.hasReadNotice && this.$store.state.isMobile) || (!this.hasReadNotice && !this.$store.state.isMobile && !this.$store.state.ticketDetail.teamInfoRegister)) return this.$message.error('请阅读并勾选预约须知')
        if (this.$store.state.ticketDetail.imgOrgOn && !this.certificate.length) {
          this.clearModelFile()
          return this.$message.error('请上传团队凭证')
        }

        if (this.selectGroupId) { //选已有的团队
          let query = {
            belongId: this.selectGroupId,
            needExplain: this.needExplain * 1,
            museumName: this.$store.state.museumName,
            museumCode: this.museumCode,
            selectedDate: this.selectedDate,
            timeId: this.timeIn.id,
            timeLabel: this.timeIn.label.split(' ')[0],
            maxExplainNum: this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
          }
          if (this.hasProject == 2) { //有项目预约
            let flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
            let chairNum = this.chairNum ? parseInt(this.chairNum) : 0
            if (flyingCinemaNum > this.maxProjectNum_f || chairNum > this.maxProjectNum_c) {
              return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
            }
            query.flyingCinemaNum = flyingCinemaNum
            query.chairNum = chairNum
          }
          if (this.$store.state.ticketDetail.imgOrgOn || this.$store.state.ticketDetail.imgPersonOn) { //需要上传团队或者个人凭证
            query.imgOrgOn = 1
          }

          if (!this.$store.state.ticketDetail.teamInfoRegister) { //团队预约不需要成员直接预约
            return this.directReservation(query)
          }
          let params = {
            certificate: this.certificate
          }
          //微服务的场馆团队预约新接口
          if (this.isFid) return this.newSetOrder(query, params)
          return this.$router.push({ name: 'groupDetail', query, params: params })
        }
        // 新增团队
        if (!this.team.orgName || !this.team.personName || !this.team.phone || !this.team.cardNum) {
          this.clearModelFile()
          // this.$refs.uploadModel.clearFiles();
          return this.$message.error('请将选择常用团队或将新建团队信息填写完整！')
        }
        this.team.personType = 4
        this.team.cardType = 1
        this.postAddPersonal(this.team, 'groupCharge')
      }
      if (type == 1) { //个人预约点击确定
        if (this.$store.state.ticketDetail.imgPersonOn && !this.certificate.length) return this.$message.error('请上传个人凭证')
        if (!this.hasReadNotice) return this.$message.error('请阅读并勾选预约须知')
        // this.selectPersons = selectData : this.selectChilds = selectData
        let peopleIds = this.personals.filter((item, index) => {
          return this.selectPersons.indexOf(index) > -1
        })
        let childs = this.childs.filter((item, index) => {
          return this.selectChilds.indexOf(index) > -1
        })
        // childNumber
        if (!peopleIds.length) return this.$message.error('请选择参观人')
        if (((this.fillChildrenInfo && !childs.length) || (!this.fillChildrenInfo && !this.childNumber)) && this.hasChild == 2) return this.$message.error('您点击了携带儿童，请选择儿童')
        if (this.hasChild == 1) {
          peopleIds = peopleIds.map((item) => { return item.id })
        } else {
          if (this.fillChildrenInfo) {
            peopleIds = peopleIds.map((item) => { return item.id }).concat(childs.map((item) => { return item.id }))
          } else {
            peopleIds = peopleIds.map((item) => { return item.id })
          }
        }
        let data = {
          museumCode: this.museumCode,
          bookingDate: this.selectedDate.replace(/\//g, '-'),
          timeSettingId: this.timeIn.id,
          orderType: 2,
          peopleIds: peopleIds,
          childOn: this.hasChild == 1 ? false : true,
          belongNum: this.hasChild == 2 ? (this.fillChildrenInfo ? this.selectChilds.length : parseInt(this.childNumber)) : undefined,
          ticketInfoId: this.$store.state.ticketDetail.id,
          certificate: this.$store.state.ticketDetail.imgPersonOn || this.$store.state.ticketDetail.imgOrgOn ? this.certificate.join('|') : undefined,
        }
        if (this.hasProject == 2) {
          data.flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
          data.chairNum = this.chairNum ? parseInt(this.chairNum) : 0
          if (data.flyingCinemaNum > this.maxProjectNum_f || data.chairNum > this.maxProjectNum_c) {
            return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
          }
        }
        if (this.hasClick) return
        if (this.isFid) { //新的个人预约
          // return console.log(data)
          this.$ajax.post('/api/ticket/front/order/personal', data).then((res) => {
            this.hasClick = false
            let query = this.$route.query
            query.orderId = res.data
            this.$router.push({ path: '/ticket/re_success', query })
          }).catch((err) => {
            this.hasClick = false
          })
          return
        }
        this.hasClick = true
        this.$ajax.post('/api/ticket/front/order', data).then((res) => {
          this.hasClick = false
          let query = this.$route.query
          query.orderId = res.data
          this.$router.push({ path: '/ticket/re_success', query })
        }).catch((err) => {
          this.hasClick = false
        })
      }
    },

    actionModel(params) {
      this.formData = new FormData();
      // let formData = new FormData();
      this.formData.append("file", params.file);
      if (this.showAddNewGroup) {
        return this.handelButton(this.reservationType)
      }
      let config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      if (!this.selectGroupId) return this.$message.error('请选择团队')
      this.$ajax.post(`/api/ticket/front/people/import-excel?museumCode=${this.museumCode}&belongId=${this.selectGroupId}`, this.formData, config).then((res) => {
        if (res.status == 200) {
          this.hasModel = true
          this.$message.success('上传成功')
        }
      })
    },

    handelShowAdd(data, type, editType) {
      this.addType = type
      this.editDetaiType = editType
      if (type == 'child' && editType == 'add' && this.$store.state.ticketDetail.childCardNumOn) {
        this.addDetail.cardType = 1
      }
      this.showAdd = data
    },

    selectTime(item, index) {
      this.timeIn = item
      this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
      this.selectedTimeIndex = index
    },

    // 保存编辑或者新增的数据
    saveAddPerson(data) {
      if (this.addType == 'personal' && (!data.cardNum || !data.cardType || !data.personName || !data.phone)) {
        return this.$message.error('请填写完整信息，不可为空！')

      }
      // if (this.$store.state.ticketDetail.childAgeMin || this.$store.state.ticketDetail.childAgeMax) {
      let ticketDetail = this.$store.state.ticketDetail
      if (this.addType == 'child' && ((ticketDetail.childAgeMax && this.addDetail.age > ticketDetail.childAgeMax) || (ticketDetail.childAgeMin && this.addDetail.age < ticketDetail.childAgeMin))) return this.$message.error(`携带的儿童年龄要求在${ticketDetail.childAgeMin}~${ticketDetail.childAgeMax}岁之间`)
      // }

      if (this.addType == 'personal') {
        if (data.phone && !/^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(data.phone)) return this.$message.warning('请输入正确的手机号')
        if (!data.cardNum || !data.personName || !data.phone || !data.cardType) return this.$message.warning('请将基础信息填写完整！')
      } else {
        if (!data.personName || !data.age || !data.gender) return this.$message.warning('请将基础信息填写完整！')
        if (this.$store.state.ticketDetail.childCardNumOn && !data.cardNum) return this.$message.warning('请将基础信息填写完整！')
      }
      if (this.editDetaiType != 'add' && this.editDetaiType != 'addUserInfo') {
        return this.postEditPersonal(data)
      }
      // 个人：2，儿童：3
      this.addType == 'personal' ? data.personType = 2 : data.personType = 3
      console.log(data)
      this.postAddPersonal(data)
    },

    // 提交编辑
    postEditPersonal(data) {
      if (this.hasClick) return
      this.hasClick = true
      this.$ajax.put('/api/ticket/front/people', data).then((res) => {
        this.showAdd = false
        this.hasClick = false
        this.getPeopleInfo(this.belongId, this.addType == 'personal' ? 2 : 3)
      }).catch((error) => {
        this.hasClick = false
      })
    },

    // 提交新增
    postAddPersonal(data, type) {
      console.log(data)
      console.log(type)
      data.museumCode = this.museumCode
      if (!type && this.editDetaiType != 'addUserInfo') { //普通的添加（个人列表或者携带儿童）
        data.belongId = this.belongId
        console.log(1)
      }
      if (this.hasClick) return
      this.hasClick = true
      this.$ajax.post('/api/ticket/front/people', data).then((res) => {
        console.log(res)
        this.hasClick = false
        this.showAdd = false
        if (!this.personals.length) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = data.phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
          console.log(2)

        }
        if (!type) {
          if (!this.belongId) {
            console.log(3)
            return location.reload()
          }
          this.getPeopleInfo(this.belongId, this.addType == 'personal' ? 2 : 3)
        } else if (type == 'groupCharge') { //添加团队负责人，后续操作
          this.getBelongInfo(type)
          console.log(4)
        }
      }).catch((error) => {
        console.log(error)
        this.hasClick = false
        console.log(5)
        // this.clearModelFile()
      })
    },

    // 删除参观人
    delData(index, type) {
      let id = type == 'personal' ? this.personals[index].id : this.childs[index].id
      this.$ajax.delete(`/api/ticket/front/people/${id}`).then((res) => {
        this.getPeopleInfo(this.belongId, type == 'personal' ? 2 : 3)
      })
    },

    changeSelectData(selectData, type) {
      if (type == 'personal') {
        this.maxChildNum = selectData.length * (this.$store.state.ticketDetail.childNumMax || 1)
        return this.selectPersons = selectData
      }
      this.selectChilds = selectData
    },

    editPersonal(index, type) {
      this.addType = type
      this.editDetaiType = index
      this.addDetail.id = type == 'personal' ? this.personals[index].id : this.childs[index].id
      // 天津文保
      if (this.$route.query.museumCode == 215314 || this.$route.query.museumCode == 200090) {
        this.addDetail.haveOrder = false
      }
      this.showAdd = true
    },

    // 根据id获取未脱敏的数据
    changeAddDetail(res) {
      this.addDetail = res
      // 天津文保
      if (this.$route.query.museumCode == 215314 || this.$route.query.museumCode == 200090) {
        if (this.addDetail.id == this.$cookie.get('belongId')) {
          this.addDetail.phoneDisabled = true
        } else {
          this.addDetail.haveOrder = false
        }
      } else {
        if (this.addDetail.phone == this.$store.state.userPhone) {
          this.addDetail.phoneDisabled = true
        }
      }
    },

    onConfirm(value, index) {
      this.timeIn = value
      this.maxExplainNum = this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
      this.showPopup = false
    },
    onChange(picker, value, index) {
    },
    onCancel() {
      this.showPopup = false
    },

    getBelongInfo(type) {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=${this.reservationType == 1 ? 2 : 4}`).then((res) => {
        let t = !res.data || !res.data.length
        if (t && this.reservationType == 1) {
          return
        }
        this.belongData = res.data
        if (!this.belongData.length) this.addNewGroup()
        if (this.belongData.length && !this.$cookie.get('ticket_phone')) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = this.belongData[0].phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
        }
        if (type == 'groupCharge') {
          // 没有上传成员模板提交
          this.$store.state.selectGroup = this.belongData[this.belongData.length - 1]
          let query = {
            belongId: this.belongData[this.belongData.length - 1].id,
            museumCode: this.museumCode,
            selectedDate: this.selectedDate,
            timeId: this.timeIn.id,
            timeLabel: this.timeIn.label.split(' ')[0],
            maxExplainNum: this.timeIn.voiceNum ? this.timeIn.voiceNum - this.timeIn.explainCount : 'no'
          }
          if (this.$store.state.ticketDetail.imgOrgOn || this.$store.state.ticketDetail.imgPersonOn) {
            query.imgOrgOn = 1
          }

          if (!this.$store.state.ticketDetail.teamInfoRegister) { //不需要成员直接预约
            return this.directReservation(query)
          }
          let params = {
            certificate: this.certificate
          }
          //微服务的场馆团队预约新接口
          if (this.isFid) return this.newSetOrder(query, params)
          return this.$router.push({ name: 'groupDetail', query, params })
        }
        this.belongId = this.belongData[0] ? this.belongData[0].id : ''
        this.getPeopleInfo(this.belongId, this.reservationType == 1 ? 2 : 1)
      })
    },
    // 微服务的新的上传团队
    newSetOrder(query, params) {
      if (this.hasClick) return
      this.hasClick = true
      let data = {
        museumCode: this.museumCode,
        bookingDate: query.selectedDate.replace(/\//g, '-'),
        timeSettingId: query.timeId,
        orderType: 1,
        peopleIds: [query.belongId],
        explainOn: query.needExplain * 1 == 2 ? true : false,
        certificate: query.imgOrgOn ? this.certificate.join('|') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id,
      }
      this.$ajax.post('/api/ticket/front/order/temp', data).then((res) => {
        this.hasClick = false
        let querys = this.$route.query
        querys.orderId = res.data
        querys.belongId = query.belongId
        this.$router.push({ path: '/ticket/groupDetail', query: querys })
      }).catch((err) => {
        this.hasClick = false
      })
    },

    // 不需要成员信息，直接生成订单
    directReservation(query) {
      if (this.hasClick) return
      this.hasClick = true
      let data = {
        museumCode: this.museumCode,
        bookingDate: query.selectedDate.replace(/\//g, '-'),
        timeSettingId: query.timeId,
        orderType: 1,
        peopleIds: [query.belongId],
        explainOn: query.needExplain * 1 == 2 ? true : false,
        belongNum: this.teamNumber,
        certificate: query.imgOrgOn ? this.certificate.join('|') : undefined,
        ticketInfoId: this.$store.state.ticketDetail.id,
      }
      if (this.hasProject == 2) {
        data.flyingCinemaNum = this.flyingCinemaNum ? parseInt(this.flyingCinemaNum) : 0
        data.chairNum = this.chairNum ? parseInt(this.chairNum) : 0
        if (data.flyingCinemaNum > this.maxProjectNum_f || data.chairNum > this.maxProjectNum_c) {
          return this.$message.error('场馆预约数量超过最大值，请核对后重新填写')
        }
      }
      if (this.isFid) { //微服务新的接口
        this.$ajax.post('/api/ticket/front/order/temp', data).then((res) => {
          this.hasClick = false
          let query = this.$route.query
          query.orderId = res.data
          this.$router.push({ path: '/ticket/re_success', query })
        }).catch((err) => {
          this.hasClick = false
        })
        return
      }
      this.$ajax.post('/api/ticket/front/order', data).then((res) => {
        this.hasClick = false
        let query = this.$route.query
        query.orderId = res.data
        this.$router.push({ path: '/ticket/re_success', query })
      }).catch((err) => {
        this.hasClick = false
      })
    },

    getPeopleInfo(id, type) {
      this.$ajax(`/api/ticket/front/people/info?museumCode=${this.museumCode}&belongId=${id}&personType=${type}`).then((res) => {
        switch (type) {
          case 1: //团队人员列表
            this.personals = res.data
            break;
          case 2:
            this.personals = res.data
            break;
          case 3: //团队人员列表
            this.childs = res.data
            break;
          case 4: //团队人员列表
            this.team = res.data
            break;
        }
      })
    },

    selectedHasChild(val) {
      this.getPeopleInfo(this.belongId, 3)
      this.hasChild = val
    },

    getTicketDetail() {
      if (this.$store.state.ticketDetail.id) {
        if (!this.$route.query.type) {
          this.reservationType = this.$store.state.ticketDetail.perOn ? 1 : 2
        }
        this.fillChildrenInfo = !this.isFid ? true : this.$store.state.ticketDetail.fillChildrenInfo
        return this.setTime()
      }
      let url = this.$route.query.code ? `/api/ticket/front/ticket-info/code?museumCode=${this.$route.query.museumCode}&code=${this.$route.query.code}` : `/api/ticket/front/ticket-info?museumCode=${this.$route.query.museumCode}${this.$route.query.id ? `&ticketInfoId=${this.$route.query.id}` : ''}`
      this.$ajax.get(url).then((res) => {
        this.$store.state.ticketDetail = res.data[0]
        this.fillChildrenInfo = !this.isFid ? true : this.$store.state.ticketDetail.fillChildrenInfo
        if (!this.$route.query.type) {
          this.reservationType = this.$store.state.ticketDetail.perOn ? 1 : 2
        }
        this.setTime()
      })
    },

    setTime() {
      let nowDate = new Date()
      let date = new Date()
      let advanceBookingDays = this.$store.state.ticketDetail.advanceBookingDays ? (this.$store.state.ticketDetail.advanceBookingDays) * 24 * 60 * 60 * 1000 : 0
      this.advanceBookingDays = advanceBookingDays
      let startDate = nowDate.getTime() + advanceBookingDays
      // let startDate = nowDate.getTime()
      console.log('advanceBookingDays')
      console.log(this.advanceBookingDays)
      // let startDate = nowDate.getTime()
      startDate = new Date(nowDate.setTime(startDate))
      let endDate = date.getTime() + (this.$store.state.ticketDetail.bookingDays ? this.$store.state.ticketDetail.bookingDays - 1 : -1) * 24 * 60 * 60 * 1000 + advanceBookingDays
      endDate = new Date(date.setTime(endDate))
      console.log('endDate')
      console.log(endDate)
      console.log('startDate')
      console.log(startDate)
      let end = [`${endDate.getFullYear()}`, `${endDate.getMonth() + 1}`, `${endDate.getDate()}`]
      this.calendar1.end = end
      this.calendar1.begin = [`${startDate.getFullYear()}`, `${startDate.getMonth() + 1}`, `${startDate.getDate()}`]
      this.calendar1.events = {
        hasClose: !this.$store.state.ticketDetail.dateClose && !this.$store.state.ticketDetail.customCloseStart ? false : true,
        week: this.$store.state.ticketDetail.dateClose ? this.$store.state.ticketDetail.dateClose.split(',') : '',
        customCloseEnd: this.$store.state.ticketDetail.customCloseEnd ? new Date(this.$store.state.ticketDetail.customCloseEnd) : '',
        customCloseStart: this.$store.state.ticketDetail.customCloseStart ? new Date(this.$store.state.ticketDetail.customCloseStart) : '',
        customCloseDate: this.$store.state.ticketDetail.customCloseDate ? this.$store.state.ticketDetail.customCloseDate : '',
        advanceBookingDays: advanceBookingDays
      }
      console.log('this.calendar1.events')
      console.log(this.calendar1)
      console.log(this.calendar1.events)
    },

    hasRead() {
      if (this.showExplaxinInfo) {
        return this.showExplaxinInfo = false
      }
      if (this.readTime) return
      this.showNotice = false
      this.hasReadNotice = true
      this.hasOpenNotice = true
    },

    // 获取个人信息（type为2的信息）
    getUserInfo() {
      // 获取手机号
      if (this.$route.query.phone && this.$route.query.phone !== '') {
        this.$store.state.userPhone = this.$route.query.phone
        this.getbelonginfo()
      } else {
        this.$ajax('/api/ticket/front/people/get-phone').then((res) => {
          this.$store.state.userPhone = res.data
          this.getbelonginfo()
        })
      }
    },
    getbelonginfo() {
      this.$ajax(`/api/ticket/front/people/belong-info?museumCode=${this.museumCode}&personType=2`).then((res) => {
        let t = !res.data || !res.data.length
        if (!t) return this.getUserInfoDetail(res.data[0].id)
        //没有过常用联系人
        if (this.$route.query.type) {
          this.reservationType = parseInt(this.$route.query.type)
        }
        if (this.$store.state.userPhone) {
          this.addDetail.phone = this.$store.state.userPhone
          this.addDetail.phoneDisabled = true
        }
        this.handelShowAdd(true, 'personal', 'addUserInfo')
      })
    },

    // 根据id获取未脱敏的数据
    getUserInfoDetail(id) {
      this.$cookie.set('belongId', id)
      this.$ajax.get(`/api/ticket/front/people/get-by-id?id=${id}`).then((res) => {
        res = res.data
        this.userInfo = res
        if (this.$route.query.type) {
          this.reservationType = parseInt(this.$route.query.type)
        }
      })
    },

    // 获取常用团队
    getCommonInfo(id) {
      this.$ajax.get(`/api/ticket/front/people/common?museumCode=${this.museumCode}&type=2`).then((res) => {
        this.belongData = res.data
        if (!this.belongData.length) this.addNewGroup()
        if (this.belongData.length && !this.$cookie.get('ticket_phone')) {
          var pat = /(\d{3})\d*(\d{4})/;
          let phone = this.belongData[0].phone.replace(pat, '$1****$2');
          this.$cookie.set('ticket_phone', phone)
        }
      })
    },

    // 获取讲解说明
    getNoticeInfo() {
      this.$ajax(`/api/admin/front/dict/codeDictAll/jjsm?museumCode=${this.museumCode}`).then((res) => {
        this.explainInfo = res.data.description
      })
    }
  },

  mounted() {
    this.museumCode = this.$route.query.museumCode || this.$cookie.get('museumCode')
    // 金湾区博物馆讲解说明
    if (this.museumCode == 212594 || this.museumCode == '200090') {
      this.getNoticeInfo()
    }
    this.getTicketDetail()
    this.getUserInfo()
    // this.$store.state.userPhone = '18865916211'
  },

  created() {
    this.isFid = !isNaN(Number(this.$route.query.museumCode)) ? true : false


  },

  computed: {
    maxPersonal() {
      return this.$store.state.ticketDetail.bookingDayMax || 3
    }
  },

  watch: {
    showAdd: {
      handler(val, valOld) {
        if (!val) {
          this.addDetail = {}
        }
      }
    },
    reservationType: {
      handler(val, valOld) {
        this.certificate = []
        this.personals = []
        val == 1 ? this.getBelongInfo() : this.getCommonInfo()
        this.hasOpenNotice = false
        this.hasReadNotice = false
        this.getTimeDetail()
      }
    },
    selectedDate: {
      handler(val, valOld) {
        this.getTimeDetail()
      }
    },
    showNotice: {
      handler(val, valOld) {
        if (val) {
          if (this.hasOpenNotice) return
          this.readTime = 3
          timeInterval = setInterval(() => {
            if (!this.readTime) return clearInterval(timeInterval)
            this.readTime--
          }, 1000)
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.reservation {
  width: 10rem;
  overflow: hidden;

  &.onPage {
    overflow: hidden;
    height: 100vh;
  }

  .bigImg {
    position: fixed;
    width: 100vw;
    height: 100vh;
    background-color: #333;
    top: 0;
    left: 0;
    z-index: 22;

    .placeholder {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 21;
    }

    .imgWarp {
      width: 100%;
      height: 80vh;
      margin: 10vh auto;
    }

    img {
      object-fit: contain;
      height: 100%;
      width: 100%;
    }
  }

  .members {
    margin: 0.5rem 0.6rem;
    display: flex;
    justify-content: space-between;
    font-size: 0.5rem;
    font-weight: 500;
  }

  .explainInfo {
    font-size: 0.42rem;
    text-align: left;
    margin: 0.15rem 0 0.3rem 0;
  }

  .fileDemo {
    font-size: 0.4rem;
    text-align: left;
    margin-left: 0.7rem;
    margin-bottom: 0.5rem;
  }

  .explain,
  .certificate {
    // display: flex;
    // justify-content: flex-start;
    // align-items: center;
    text-align: left;
    padding: 0.3rem 0.5rem;

    .contentTitle {
      display: inline-block;
    }

    .upload-demo {
      display: inline-block;
    }
  }

  .certificate .uploadImgs {
    margin-top: 0.5rem;
    width: 32%;
    height: 32vw;
    margin-right: 1%;
    position: relative;
    display: inline-block;
    vertical-align: top;
  }

  .certificate .uploadImgs img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    overflow: hidden;
  }

  .certificate .uploadImgs span {
    height: 0.8rem;
    width: 0.8rem;
    position: absolute;
    top: -0.5rem;
    left: 0rem;
    background: url('../../assets/close_fill.png') 0 0/100% 100% no-repeat;
  }

  .isMobile .upload-demo {
    margin-top: -0.15rem;
  }

  .pcItemCard {
    .explain {
      margin: 0.2rem 0;
      padding: 0;
      padding-left: 45px;
      margin-right: 30px;
      vertical-align: middle;

      // justify-content: flex-start;
      &:before {
        left: 0px;
      }
    }

    .el-radio-group {
      margin-top: 0 !important;
    }

    .buttonGroup {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin: 0.2rem 0;
      cursor: pointer;

      div {
        padding: 0 0.1rem;
        margin: 0 0.2rem 0.2rem 0;
      }

      .gray {
        opacity: 0.5;
      }
    }

    .addGroup {
      &:before {
        display: none;
      }

      padding-left: 0;
      color: #fff;
    }

    .explainInfo {
      font-size: 20px;
      text-align: left;
      margin: 0 0 0 85px;
      cursor: pointer;
      display: inline-block;
      vertical-align: middle;
    }
  }

  .button3 {
    margin: auto;
  }

  .closeReservation {
    font-size: 0.42rem;
    margin-bottom: 0.5rem;
    margin-top: -0.7rem;
  }

  .timeInSelected {
    font-size: 0.4rem;
    width: 5.1rem;
    text-align: left;
    position: relative;
    padding: 0.25rem 0.2rem;
    background: #fff;
    border-radius: 0.2rem;

    &::after {
      display: inline-block;
      content: '';
      position: absolute;
      top: 0.28rem;
      right: 0.3rem;
      width: 0.5rem;
      height: 0.4rem;
      background: url('../../assets/down.png') 0 0/100% no-repeat;
    }
  }

  .calendarWarp {
    height: 9rem;
    width: 10rem;
    position: relative;

    .calendarDetail {
      background-color: #f6f6f6;
      margin: 0.5rem;
      padding: 0.3rem 0;
      border-radius: 0.3rem;
    }
  }

  .buttonLine {
    width: 100%;
    margin: auto;
    position: relative;

    div {
      display: inline-block;
    }

    .buttonRed {
      margin-right: 0.5rem;
    }

    .pcToIndex {
      position: absolute;
      top: 10px;
      right: 10px;
    }
  }

  .line {
    font-size: 24px;
    font-weight: 500;
    text-align: center;
    line-height: 36px;
    margin: 35px 0;

    span {
      margin-left: 0.2rem;
      font-size: 22px;
    }
  }

  .pcCalendar {
    width: 830px;
    position: relative;

    &:after {
      content: '';
      display: inline-block;
      width: 180px;
      height: 370px;
      // background: url('~@/assets/ticket/date.png') 0 0/cover no-repeat;
      position: absolute;
      top: 0;
      right: -180px;
      z-index: 22;
    }

    .mouthText {
      font-size: 25px;
      position: absolute;
      top: 156px;
      right: -100px;
      color: #fff;
      z-index: 222
    }
  }

  .popWarp .tips {
    font-size: 18px;
    line-height: 36px;
    margin-top: 15px;
    text-align: left;
    margin-left: 30px
  }

  .pcItemCard {
    text-align: left;

    .closeReservation {
      margin-top: 0.5rem;
      font-size: 0.18rem;
    }
  }

  .timeAndTicket {
    display: inline-block;
    font-size: 0.1rem;
    width: 1.3rem;
    height: 0.42rem;
    line-height: 0.42rem;
    margin-right: 0.55rem;
    margin-bottom: 0.1rem;
    border: 1px solid #d2d2d2;
    text-align: center;
    border-radius: 0.1rem;
    cursor: pointer;
    background-color: #fff;
  }

  .selectedTime {
    // background: url('~@/assets/ticket/buttonSelect.png') 0 0/contain no-repeat;
    // border: unset;
    width: 1.31rem;
    height: 0.42rem;
  }

  .buttonsWarp {
    // padding: 0 2.5rem;
  }

  .groupItem {
    font-size: 20px;
    border: 1px solid #fff;
    background-color: #fff;
    min-width: 0.8rem;
    text-align: center;
    height: 45px;
    line-height: 45px;
    padding: 0 10px;
    border-radius: 0.2rem;
    display: inline-block;
    margin-right: 30px;
    margin-bottom: 30px;
    cursor: pointer;
  }

  .addNewGroup {
    font-size: 0.45rem;
    text-align: left;
    margin-left: 0.8rem;
    margin-bottom: 10px;
  }

  .popHasRead {
    font-size: 20px;
    width: 160px;
    height: 52px;
    line-height: 52px;
    margin-top: 30px;
  }

  .gayText {
    opacity: 0.9;
    background: #999;
  }

  .popNoticeContent {
    overflow-y: scroll;
    height: 500px;
  }

  .popContentTitle {
    font-size: 36px;
    text-align: center;
    font-weight: 500;
    margin-bottom: 40px;
  }

  .popNotice {
    font-size: 24px;
    line-height: 36px;
    // overflow: scroll;
  }

  .pcStopTime {
    display: inline-block;
    margin-left: 30px;
  }
}
</style>
<style type="text/css" lang="scss">
.itemContentTitle {
  margin: 0 0.7rem;
  font-weight: 500;
  font-size: 0.45rem;
  text-align: left;
}

.reservation {
  .otherH5Project {
    .hasProject {
      margin-bottom: 1.8rem;
      position: relative;
    }

    .projectTitle {
      display: inline-block;
    }

    .projectWarp {
      position: absolute;
      left: 0;
      top: 0.8rem;
      text-align: left;
    }

    .el-input {
      width: 2.2rem;
    }

    .itemWarp {
      height: auto
    }

    .el-input__inner {
      height: 0.8rem;
      line-height: 0.8rem;
      color: #000;
      border: 1px solid #DCDFE6;
      margin-bottom: 0.2rem;
    }
  }
}

.otherPcProject {
  position: relative;

  .projectWarp {
    display: flex;
    align-items: center;
    margin-top: 5px;
    position: absolute;
    bottom: 30px;
  }

  .projectTitle {
    display: inline-block;
    font-size: 18px;
    width: auto;
    margin-left: 40px;
  }

  .el-input {
    width: 100px;
  }

  .el-input__inner {
    color: #000;
    border: 1px solid #DCDFE6;
  }
}

.reservation {
  .itemWarp {
    display: flex;
    align-items: center;
    font-size: 0.45rem;
    font-weight: 500;
    height: 0.9rem;
  }

  .itemWarpTime {
    display: flex;
    // justify-content: center;
    align-items: center;
    font-size: 0.45rem;
    font-weight: 500;
    height: 0.9rem;

    &.timeWarp {
      margin-bottom: 0.2rem;
    }

    .contentTitle {
      margin-left: 0.6rem;
    }
  }

  .pcContent {
    .nameBlock {
      border: 1px solid #d2d2d2;
    }

    .nameWarp {
      margin-top: 0.15rem;
    }

    .add {
      font-size: 27px;
    }

    .contentTitle {
      font-size: 26px;
    }

    .certificate {
      display: flex;
      justify-content: flex-start;
      text-align: left;
      align-items: center;
      padding: 0;
      margin: 0;
      font-size: 26px;
      height: 50px;
      margin-top: 0;

      .contentTitle {
        padding-left: 45px;
        line-height: 50px;
      }

      .contentTitle:before {
        top: 10px;
        left: 0px;
        // display: none;
      }
    }

    .fileDemo {
      margin-left: 0.5rem;
    }

    .uploadImgs img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
    }

    .uploadImgs {
      margin-top: 0.5rem;
      margin-right: 1%;
      position: relative;
      display: inline-block;
      vertical-align: top;
      width: 10%;
      height: 1rem;
      margin-top: 0.2rem;
      cursor: pointer;
    }

    .uploadImgs span {
      position: absolute;
      background: url('../../assets/close_fill.png') 0 0/100% 100% no-repeat;
      top: -0.15rem;
      left: -0.05rem;
      height: 0.2rem;
      width: 0.2rem;
      cursor: pointer;
    }

    .fileDemo {
      font-size: 20px;
      margin-bottom: 0;
      cursor: pointer;
    }
  }
}

.reservation .pcCalendar {

  th,
  td {
    width: 110px !important;
  }

  .calendar td.week {
    font-size: 22px;
    height: 80px;
    line-height: 80px;
  }

  .calendar td span {
    font-size: 26px;
  }

  .calendar td {
    height: 88px;
  }

  tr,
  thead,
  .swiper-container,
  .swiper-wrapper,
  .swiper-slide {
    width: 100% !important;
    background-color: #fff;
  }

  tbody {
    padding-bottom: 5px;
    background-color: #fff;
  }

  .calendar-tools {
    top: unset;
  }

  .calendar td span {
    margin: 30px auto 0 auto;
  }

  .calendar td .text {
    width: 110px;
  }

  .calendar td.selected::after {
    left: 24px;
    width: 64px;
    height: 64px;
    top: 11px;
  }

  .calendar-info>div.month {
    margin-top: 120px;
    // right: 140px;
    // position: absolute;
  }

  .calendar-info>div.month .month-inner {
    color: #fff;
  }
}

.buttonLine .el-input__inner {
  height: 0.28rem;
  line-height: 0.28rem;
}

.timeDetail {
  margin-top: 35px;
}

.reservation .pcItemCard {
  .timeDetail {
    .timeAndTicket {
      width: 228px;
      line-height: 68px;
      height: 68px;
      margin-right: 28px;
      border-radius: 15px;
      margin-bottom: 28px;
      font-size: 20px;

      &:nth-child(4n+1) {
        margin-right: 0;
      }
    }

    .selectedTime {
      width: 226px;
      line-height: 66px;
      height: 66px;
      background-size: 100% 100%;
    }
  }

  .left,
  .right {
    overflow: auto;
  }

  .lineBgc {
    margin: 30px 0;
    padding: 40px 80px;
    background-color: #fff;
    border-radius: 16px;
    position: relative;

    &:after {
      position: absolute;
      display: inline-block;
      width: 3px;
      height: 80%;
      content: "";
      top: 10%;
      left: calc(50% - 1px);
    }
  }
}

.reservation .buttonsWarp {
  margin-top: 30px;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .upload-demo,
  .button3 {
    width: 315px;
    height: 65px;
  }

  .button3 {
    margin: 0 !important;
  }
}

.reservation .popNotice p {
  margin: 0;
}

.reservation .pcContent .lineBgc {
  .lineContent .el-input__inner {
    font-size: 20px;
  }

  .lineContent .name {
    width: 130px;
  }

  .lineContent .el-input {
    width: 270px;
  }
}

.reservation .pcContent {
  .teamNumber .itemWarpLine {
    min-height: 50px;
  }
}

.reservation .popNotice {
  text-align: left;
}
</style>
